import { html, LitElement } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import { unsafeSVG } from 'lit-html/directives/unsafe-svg';
import Styles from './styles.scss';
import spinner from './spinner';

export default class AabSpinner extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    // Initialize LitElement properties here
    this.svg = spinner;
    this.size = 5;
    this.hideOverlay = false;
  }

  static get properties() {
    return {
      // LitElement properties here
      text: { type: String },
      size: { type: Number },
      hideOverlay: { type: Boolean, attribute: 'hide-overlay' },
    };
  }

  static get styles() {
    return [Styles];
  }

  updated() {
    this.shadowRoot.querySelector('.spinner-icon')
      .setAttribute('style', `height: ${this.size * 8}px; width:${this.size * 8}px;`);
  }

  render() {
    return html`
        <span class="d-flex justify-content-center align-items-center  ${this.hideOverlay ? 'm-1' : 'spinner-overlay'}">
            <div class="spinner-icon ie-loader-animation">
                ${unsafeSVG(this.svg)}
            </div>
            <span class="spinner-text ml-1">
                ${this.text}
            </span>
        </span>`;
  }
}
